module.exports = __webpack_public_path__ + "img/image-01.a818aa7f.webp";